<template>
  <span class="d-inline-block position-relative text-left" :title="texto">
    {{ textoAExibir }}
    <b-button
      v-if="isTextoLongo"
      size="sm"
      pill
      variant="outline-secondary text-nowrap btn-tiny float-right"
      title="Copiar texto"
      class="ml-2"
      @click="copiarTexto(texto)"
    >
      <font-awesome-icon icon="clipboard" class="" />
      copiar
    </b-button>
  </span>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";

const CompProps = Vue.extend({
  name: "TextoLongo",
  props: {
    texto: {
      type: String,
      default: "",
    },
    limite: {
      type: Number,
      default: 30,
    },
  },
});

@Component
export default class TextoLongo extends mixins(UtilsTS, CompProps) {
  get isTextoLongo(): boolean {
    return this.texto.length > this.limite;
  }
  get textoAExibir(): string {
    return this.isTextoLongo
      ? this.texto.substring(0, this.limite) + "..."
      : this.texto;
  }
}
</script>
